import frontDesk from '@/locales/en/frontDesk/frontDesk.locales';

export default {
    ...frontDesk,
};
